import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect";
import { generateUniqueId, generateScopedCSS } from "../utils";
import { useRef, useState, useEffect } from "react";
export const useScopedStyles = (customCSS) => {
    const [scopeId, setScopeId] = useState("");
    const [isHydrated, setIsHydrated] = useState(false);
    const styleElementRef = useRef(null);
    const currentCSSRef = useRef(undefined);
    useEffect(() => {
        setIsHydrated(true);
    }, []);
    useEffect(() => {
        if (!isHydrated) {
            return;
        }
        if (customCSS) {
            if (currentCSSRef.current !== customCSS) {
                if (styleElementRef.current &&
                    styleElementRef.current.parentNode) {
                    styleElementRef.current.parentNode.removeChild(styleElementRef.current);
                    styleElementRef.current = null;
                }
                setScopeId(generateUniqueId());
                currentCSSRef.current = customCSS;
            }
        }
        else {
            if (styleElementRef.current && styleElementRef.current.parentNode) {
                styleElementRef.current.parentNode.removeChild(styleElementRef.current);
                styleElementRef.current = null;
            }
            setScopeId("");
            currentCSSRef.current = undefined;
        }
    }, [customCSS, isHydrated]);
    useIsomorphicLayoutEffect(() => {
        if (!customCSS || !scopeId || !isHydrated) {
            return;
        }
        if (styleElementRef.current) {
            return;
        }
        const styleElement = document.createElement("style");
        styleElement.setAttribute("data-scope-id", scopeId);
        try {
            const scopedCSS = generateScopedCSS(customCSS, scopeId);
            styleElement.textContent = scopedCSS;
            document.head.appendChild(styleElement);
            styleElementRef.current = styleElement;
        }
        catch (error) {
            console.error("Failed to apply scoped CSS:", error);
        }
        return () => {
            if (styleElementRef.current && styleElementRef.current.parentNode) {
                styleElementRef.current.parentNode.removeChild(styleElementRef.current);
                styleElementRef.current = null;
            }
        };
    }, [customCSS, scopeId, isHydrated]);
    return scopeId;
};
